<script setup lang="ts">
    import { computed } from "vue"
    import { useAppStore } from "~/stores"

    const appStore = useAppStore()

    const isVisible = computed(() => appStore.isChangingCompany)
    const message = computed(
        () =>
            appStore.changingCompanyMessage ||
            "Chargement des données de l'entreprise...",
    )
</script>

<template>
    <v-overlay
        v-model="isVisible"
        persistent
        class="d-flex align-center justify-center"
        :z-index="9999"
    >
        <v-card class="pa-8 text-center" elevation="24" min-width="300">
            <v-progress-circular
                indeterminate
                color="primary"
                size="64"
                width="6"
            />
            <p class="mt-4 text-h6">{{ message }}</p>
        </v-card>
    </v-overlay>
</template>
